import get = require('lodash/get');
import {TProvider} from '../../../common/types';
import {ISignUpAction} from './actions';
import {
  SIGN_UP_FULFILLED,
  SIGN_UP_REJECTED,
  SIGN_UP_PENDING,
} from './constants';

export const DEFAULT_PROVIDER: TProvider = 'pramp';

export interface ISignUpState {
  emailSent: boolean;
  isLoading: boolean;
  provider: TProvider;
  errors: string[];
}

const initialState: ISignUpState = {
  emailSent: false,
  isLoading: false,
  provider: DEFAULT_PROVIDER,
  errors: [],
};

const signUpReducer = (state: ISignUpState = initialState, action: ISignUpAction): ISignUpState => {
  const {payload, type, meta} = action;

  switch (type) {
    case SIGN_UP_PENDING:
      return {
        ... state,
        emailSent: false,
        isLoading: true,
        provider: meta.provider || DEFAULT_PROVIDER,
        errors: [],
      };

    case SIGN_UP_FULFILLED:
      return {...state, isLoading: false};

    case SIGN_UP_REJECTED:
      return {
        ...state,
        emailSent: false,
        isLoading: false,
        errors: get(payload, 'response.errors', []),
      };

    default:
      return state;
  }
};

export default signUpReducer;
